import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <h3 style={{color: 'white', marginBottom: '1rem'}}>Mohammad Kanaan</h3>
          <p style={{color: 'var(--text-tertiary)', maxWidth: '500px', margin: '0 auto'}}>
            Fullstack webbutvecklare.
          </p>
          
          <div className="footer-links">
            <a href="#home" className="footer-link">Hem</a>
            <a href="#about" className="footer-link">Om Mig</a>
            <a href="#projects" className="footer-link">Projekt</a>
            <a href="#contact" className="footer-link">Kontakt</a>
          </div>
          
          <div className="footer-copyright">
            &copy; {currentYear} Mohammad Kanaan. Alla rättigheter förbehållna.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;